<template>
  <div class="course-video">
    <gensee-video-player
      :video-id="videoSourceId"
      :auto-play="true"
    ></gensee-video-player>
    <related-videos :list="relatedVideos"></related-videos>

    <img
      src="./images/ic_online_service.png"
      alt=""
      class="icon-online-service"
      @click="openOnlineService"
    />
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs
} from '@vue/composition-api'
import http from '@/api/http'
import appInfo from '@/assets/js/appInfo'
import RelatedVideos from '@/components/RelatedVideos/RelatedVideos'
import GenseeVideoPlayer from '@/components/GenseeVideoPlayer/GenseeVideoPlayer'

export default defineComponent({
  name: 'CourseDetail',
  components: { GenseeVideoPlayer, RelatedVideos },
  setup() {
    const state = reactive({
      title: appInfo.getParam('title'),
      videoSourceId: appInfo.getParam('videoSourceId'),
      relatedVideos: []
    })

    onMounted(getRelatedVideos)

    if (state.title) {
      document.title = state.title
    }

    function getRelatedVideos() {
      http
        .get('/Video/ShizhanVideo/GetRelatedVideos', {
          title: state.title
        })
        .then(({ result, detail }) => {
          if (result.code === 0) {
            state.relatedVideos = detail
          }
        })
    }

    function openOnlineService() {
      location.href = 'ycstock://onlineservice?code=emcourse'
    }

    return {
      ...toRefs(state),
      openOnlineService
    }
  }
})
</script>

<style lang="scss" scoped>
.course-video {
  padding-top: 386px;
}

.icon-online-service {
  position: fixed;
  bottom: 100px;
  right: 10px;
  width: 120px;
}
</style>
